import {required as requiredOriginal, helpers, maxLength as maxLengthOriginal, requiredIf as requiredIfOriginal} from '@vuelidate/validators'
import dayjs from "dayjs";
const ibantools = require('ibantools')

/**
 * Validateur pour les erreurs qui sont remontées depuis l'API
 */
const serverError = (props, propertyPath) => helpers.withMessage(
    () => props.serverErrors.find(item => item.propertyPath === propertyPath) !== undefined ? props.serverErrors.find(item => item.propertyPath === propertyPath).message : 'serveur erreur',
    () => props.serverErrors.find(item => item.propertyPath === propertyPath) === undefined
)

/**
 * Validateur de type 'requis'
 */
const required = helpers.withMessage('Ce champ est requis', requiredOriginal)

/**
 * Validateur de type 'requis'
 */
const requiredIf = (param) => helpers.withMessage('Ce champ est requis', requiredIfOriginal(param))

/**
 * Validateur de type 'maxLength'
 */
const maxLength = (param) => helpers.withMessage('Nombre de caractères trop élevé', maxLengthOriginal(param))

/**
 * Validateur pour le code postal
 */
const frenchZipCode = helpers.withMessage(
    'Le code postal est invalide',
    (value) => {
        if (!value) return true
        return value.match(/[0-9]{5}/)
    }
)

/**
 * Validateur pour le IBAN
 */
const iban = helpers.withMessage(
    'L\'IBAN est invalide',
    (value) => {
        if (!value) return true
        return ibantools.isValidIBAN(value.replace(/\s/g, ''))
    }
)

/**
 * Validateur pour le numéro de sécurité social
 */
const frenchSocialSecurityNumber = helpers.withMessage(
    'Le numéro de sécurité sociale est invalide',
    (value) => {
        if (!value) return true

        // On supprime les espaces
        value = value.replace(/\s/g, '')

        // On vérifie la longueur
        if (value.length !== 15) {
            return false
        }

        const base = parseInt(value.substr(0, 13))
        const key = parseInt(value.substr(13, 2))

        console.debug('[validator]','frenchSocialSecurityNumber', base, key)

        // On vérifie que la clé est bien celle qui est attendue
        return key === (97 - base % 97)
    }
)

/**
 * Validateur date inférieure à 6 mois
 */
const dateLessThan6MonthsFromToday = helpers.withMessage(
    'La date doit être inférieure à 6 mois',
    (value) => {
        if (!value) return true
        const dateIn6Months = dayjs().add(6, 'months')
        const date = dayjs(value, 'DD/MM/YYYY', true)

        return date <= dateIn6Months
    })

/**
 * Validateur date de naissance inférieure à 20 ans à la date d'effet
 */
const childMustBeLessThan20AtEffectiveDate = (effectiveDateInDDMMYYYY) =>  helpers.withMessage(
    () => 'Vous ne pouvez assurer que des enfants de moins de 20 ans au jour de la date d\'effet.',
    (value) => {
        console.debug('childMustBeLessThan20AtEffectiveDate', value, effectiveDateInDDMMYYYY)
        const birthDate = dayjs(value, 'DD/MM/YYYY', true)
        const dateEffet = dayjs(effectiveDateInDDMMYYYY, 'DD/MM/YYYY', true)

        return birthDate.add(20, 'years') > dateEffet
    }
)

export {
    childMustBeLessThan20AtEffectiveDate,
    dateLessThan6MonthsFromToday,
    frenchSocialSecurityNumber,
    frenchZipCode,
    iban,
    maxLength,
    required,
    requiredIf,
    serverError
}
